import React, { useState, useEffect } from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Actions
import { markDNC } from '~/redux/actions/contacts-actions';
import { failure, success } from '~/redux/actions/snackbar-actions';

// Utils
import { dateFormat } from '~/utils/date-format';
import { MESSAGES } from '~/utils/message';

// MUI Components
import {
  Card,
  CardContent,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from '@mui/material';

// Components
import ContactDetailsSkeleton from '~/components/Contacts/ContactDetailsSkeleton';

// Assets
import { ContactInfoCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const ContactsMeta = ({ isLoading, orignalContactData, isEditing }) => {
  // const [selectedValue, setSelectedValue] = useState(['Company A']);
  const [isDncList, setIsDncList] = useState(false);
  const dispatch = useDispatch();

  // Update DNC state when contact data changes
  useEffect(() => {
    if (orignalContactData?.dncMarkedAt !== undefined) {
      setIsDncList(orignalContactData.dncMarkedAt !== null);
    }
  }, [orignalContactData?.dncMarkedAt]);
  // const companyOptions = [
  //   { id: 1, title: 'Company A' },
  //   { id: 2, title: 'Company B' },
  //   { id: 3, title: 'Company C' },
  // ];

  const handleMarkDNC = async () => {
    try {
      const payload = {
        contactId: orignalContactData?.id,
        markAsDnc: !isDncList,
      };
      const response = await dispatch(markDNC(payload));
      if (response.status === 200) {
        dispatch(success(response.data.message));
        setIsDncList(!isDncList);
      } else {
        dispatch(failure(response.data.message));
      }
    } catch (error) {
      dispatch(failure(error.response.data.message));
    }
  };

  return (
    <Card className="metadataCard">
      <CardContent>
        <Box className="metadataContent">
          {isLoading ? (
            <ContactDetailsSkeleton
              variant="metadata"
              isReturnAddress={orignalContactData?.isReturnAddress}
              isDncList={orignalContactData?.dncMarkedAt}
            />
          ) : (
            <>
              {/* Created by section */}
              <Box className="metadataItem">
                <Typography className="metadataLabel">Created by</Typography>
                <Typography className="metadataValue">
                  {orignalContactData?.creator?.fullName || '-'}
                </Typography>
              </Box>

              {/* Date Created section */}
              <Box className="metadataItem">
                <Typography className="metadataLabel">Created Date</Typography>
                <Typography className="metadataValue">
                  {orignalContactData?.createdAt ? dateFormat(orignalContactData.createdAt) : '-'}
                </Typography>
              </Box>

              {/* Company section */}
              {/* <Box className="metadataItem">
                <Typography className="metadataLabel">Company</Typography>
                {isEditing ? (
                    <MultiSelect
                        options={companyOptions}
                        selectedValue={selectedValue}
                        setSelectedValue={setSelectedValue}
                        placeholder="Select Company"
                        newDesign={true}
                        component={'company'}
                    />
                ) : (
                <Typography className="metadataValue">
                    {orignalContactData?.createdAt
                        ? dateFormat(orignalContactData.createdAt)
                        : '-'
                    }
                    {selectedValue.length > 0 ? selectedValue.join(', ') : '-'}
                </Typography>
                )}
            </Box> */}

              {/* Import List Name */}
              {/* <Box className="metadataItem">
                <Typography className="metadataLabel">Import List Name</Typography>
                <Typography className="metadataValue">
                  {orignalContactData?.createdAt
                      ? dateFormat(orignalContactData.createdAt)
                      : '-'
                  }
                  list with custom filed and ta...
                </Typography>
              </Box> */}

              {/* Last QR Code Scan section */}
              {/* <Box className="metadataItem">
                    <Typography className="metadataLabel">Last QR Code Scan</Typography>
                    <Typography className="metadataValue">
                        {orignalContactData?.lastQrScan?.scannedAt 
                            ? dateFormat(orignalContactData.lastQrScan.scannedAt)
                            : '-'
                        }
                    </Typography>
                  </Box> */}

              {/* Checkboxes section */}
              <Box className="checkboxSection">
                {orignalContactData?.isReturnAddress && !isEditing && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="metadataCheckbox checkedBox"
                          icon={<Box className="notChecked"></Box>}
                          checked={orignalContactData?.isReturnAddress ? true : false}
                          disabled
                        />
                      }
                      label="Use as Return Address"
                      className="checkboxLabel disabledCheckbox"
                    />
                    <Tooltip
                      title={MESSAGES.CONTACTS.RETURN_ADDRESS_TOOLTIP}
                      placement="bottom-start"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                            maxWidth: '195px',
                            padding: '8px !important',
                          },
                        },
                      }}
                    >
                      <img src={ContactInfoCIcon} alt="info" style={{ cursor: 'pointer' }} />
                    </Tooltip>
                  </Box>
                )}
                {!orignalContactData?.isReturnAddress && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isDncList}
                          icon={<Box className="notChecked"></Box>}
                          className="metadataCheckbox checkedBox"
                          onChange={handleMarkDNC}
                          style={{ color: '#ED5C2F' }}
                        />
                      }
                      label="Do Not Contact"
                      className={`checkboxLabel`}
                    />
                    <Tooltip
                      title={MESSAGES.CONTACTS.DO_NOT_CONTACT_TOOLTIP}
                      placement="bottom-start"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                            maxWidth: '195px',
                            padding: '8px !important',
                          },
                        },
                      }}
                    >
                      <img src={ContactInfoCIcon} alt="info" style={{ cursor: 'pointer' }} />
                    </Tooltip>
                  </Box>
                )}
              </Box>
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ContactsMeta;
